import { render } from "./FilterSlider.vue?vue&type=template&id=3b8498b7&scoped=true"
import script from "./FilterSlider.vue?vue&type=script&lang=js"
export * from "./FilterSlider.vue?vue&type=script&lang=js"

import "./FilterSlider.vue?vue&type=style&index=0&id=3b8498b7&scoped=true&lang=css"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8498b7"]])

export default __exports__